import { TextField } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import React from "react";
import { StyledSelectGroup } from "../../filter/styledFiter";
import FormControl from "@material-ui/core/FormControl";
import { useTranslation } from "react-i18next";

const CurrencySelect = ({
  checkedCurrency,
  setCheckedCurrency,
  mappedData,
  checkedService
}) => {
  const { t } = useTranslation("otherInterface");

  const optionsSource = checkedService
    ? mappedData?.services[checkedService]?.currencies
    : mappedData?.allCurrencies;

  return (
    <StyledSelectGroup>
      <FormControl>
        <Autocomplete
          options={optionsSource || []}
          value={checkedCurrency || null}
          onChange={(event, currency) => setCheckedCurrency(currency)}
          renderInput={(params) => (
            <TextField {...params} label={t("serviceReletionships.currency")} />
          )}
          blurOnSelect
        />
      </FormControl>
    </StyledSelectGroup>
  );
};

export default CurrencySelect;